import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit, ViewChild } from '@angular/core';
import { QuillEditorComponent } from 'ngx-quill/src/quill-editor.component';
import { EventService } from '../../Services/event.service';
import { AlertService } from '../../Services/alert.service';
import { AuthService } from '../../Services/auth.service';
import { IMyDpOptions, IMyMarkedDate, IMyDayLabels } from 'mydatepicker';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-meerdaagse-form',
  template: require('./meerdaagse-form.component.html'),
  styles: [require('./meerdaagse-form.component.css')]
})
export class MeerdaagseFormComponent implements OnInit {
  @ViewChild('editor') editor: QuillEditorComponent;
  @ViewChild('quilviewer') quilviewer: QuillEditorComponent;

  readonly evenementType = 1;

  editor_modules: any = {}
  evenement: any = {}
  viewer: boolean = false;
  viewer_theme: string = 'bubble'

  beginDate: any;
  endDate: any;
  myDatePickerOptions: IMyDpOptions = {
    todayBtnTxt: 'Vandaag',
    dateFormat: 'dd/mm/yyyy',
    firstDayOfWeek: 'mo',
    sunHighlight: true,
    markCurrentDay: true,
    height: '34px',
    width: '210px',
    alignSelectorRight: false,
    openSelectorTopOfInput: false,
    indicateInvalidDate: true,
    monthSelector: true,
    yearSelector: true,
    minYear: 1920,
    maxYear: 2200,
    componentDisabled: false,
    editableDateField:false,
    showClearDateBtn: true,
    showDecreaseDateBtn: false,
    showIncreaseDateBtn: false,
    showSelectorArrow: true,
    showInputField: true,
    openSelectorOnInputClick: false,
    disableHeaderButtons: true,
    showWeekNumbers: false,
    markDates: [],
    satHighlight: false,
    highlightDates: [],
    markWeekends: <IMyMarkedDate>{},
    monthLabels: {
        1: 'Januari',
        2: 'Februari',
        3: 'Maart',
        4: 'April',
        5: 'Mei',
        6: 'Juni',
        7: 'July',
        8: 'Augustus',
        9: 'September',
        10: 'Oktober',
        11: 'November',
        12: 'December'
    },
    dayLabels: <IMyDayLabels>{
      su: 'zo', mo: 'ma', tu: 'di', we: 'wo', th: 'do', fr: 'vr', sa: 'za'
    },
    allowDeselectDate: true,
    disableWeekdays: [],
    allowSelectionOnlyInCurrentMonth: true
  };

  constructor(private alertService: AlertService,
    private route: ActivatedRoute,
    private router: Router,
    private eventService: EventService,
    private auth: AuthService) {
    this.editor_modules = {
      toolbar: [
        ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
        ['blockquote', 'code-block'],

        // [{ 'header': 1 }, { 'header': 2 }],               // custom button values
        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
        [{ 'script': 'sub' }, { 'script': 'super' }],      // superscript/subscript
        [{ 'indent': '-1' }, { 'indent': '+1' }],          // outdent/indent
        [{ 'direction': 'rtl' }],                         // text direction

        [{ 'size': ['small', false, 'large', 'huge'] }],
        // [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

        [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
        [{ 'font': [] }],
        [{ 'align': [] }],

        ['clean'],                                         // remove formatting button

        ['link', 'image', 'video']                         // link and image, video
      ]
    }

    route.params.subscribe(p => {
      if (p['id']) {
        this.evenement.id = +p['id'];
        this.viewer = true;
      }
      else {
        this.evenement.id = 0;
        this.viewer = false;
      }

    });

  }

  ngOnInit() {
    if (this.evenement.id > 0) {
      this.eventService.getEventById(this.evenement.id).subscribe(res => {
        this.evenement = res;
        
        var bd = new Date(this.evenement.beginDate);
        this.beginDate = {
            jsdate: bd,
            date:{year: bd.getFullYear(), month: bd.getMonth() +1, day: bd.getDate()}
        }; 
        
        var ed = new Date(this.evenement.endDate);
        this.endDate = {
            jsdate: ed,
            date:{year: ed.getFullYear(), month: ed.getMonth() +1, day: ed.getDate()}
        };    
      });
    }
  }

  submit() {
    // console.log("Submit pressed");
    // console.log(this.editor.editorElem.innerHTML);
    // console.log(this.editor.editorElem.innerText);
    // this.evenement.content = this.editor.editorElem.innerHTML;
    this.evenement.beginDate = String(this.beginDate.date.year)+"-"+String(this.beginDate.date.month)+"-"+String(this.beginDate.date.day)
    this.evenement.endDate = String(this.endDate.date.year)+"-"+String(this.endDate.date.month)+"-"+String(this.endDate.date.day)
    this.evenement.eventTypeId = this.evenementType;
    // console.log("submit Evenement: ")
    // console.log(this.evenement);
    if (this.evenement.id) {
      this.eventService.update(this.evenement).subscribe(x => {
        if (x == 200)
          this.alertService.success("Meerdaagse bewaard", true)
        else
          this.alertService.error("Probleem met bewaren", true)
      });

      // this.router.navigate(['/eventlist',this.evenementType]);
    }
    else {
      this.eventService.create(this.evenement).subscribe(res => {
        // console.log(res)
        if (res['status'] == 200) {
          this.alertService.success("Meerdaagse aangemaakt.")
          this.evenement.id = res['value'].id;
        }
        else {
          this.alertService.error("Er is iets mis gegaan.")
        }
      });
    }
  }

  deleteEvenement() {
    Swal.fire({
      title: 'Ben je zeker?',
      text: "Ben je zeker dat je deze meerdaagse wil verwijderen?",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Jep',
      cancelButtonText: 'Nope'
    }).then((result) => {
      if (result.value) {
        this.eventService.delete(this.evenement).subscribe(x => {
          // console.log("Delete")
          this.router.navigate(['/meerdaagselist', this.evenementType]);
        });
      }
    });
  }

  // editorButtonClicked(){
  //   console.log("button clicked")
  //   this.editor.style["height"]= "300px";
  // }

  changeEditMode() {
    // console.log("change Edit");
    this.viewer = !this.viewer;
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/meerdaagse-form/meerdaagse-form.component.ts